var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('video',{staticClass:"tcplayer player-size",attrs:{"id":"player-container-id","preload":"auto","playsinline":"","webkit-playinline":"","x5-playinline":""}}),_vm._v(" "),_c('remote-js',{attrs:{"src":"https://imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.min.js"},on:{"completed":_vm.initPlayer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31aaa416","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qPlayer.vue
// module id = null
// module chunks = 